<template>
  <div v-if="currEnv === 'production'" />
  <div v-else-if="currEnv === 'staging'">
    <div class="banner-container">
      <div class="banner-stage">
        <span>
          Staging Environment
        </span>
      </div>
    </div>
  </div>
  <div v-else-if="currEnv === 'develop'">
    <div class="banner-container">
      <div class="banner-dev">
        <span>
          Development Environment
        </span>
      </div>
    </div>
  </div>
  <div v-else-if="currEnv === 'demo'">
    <div class="banner-container">
      <div class="banner-stage">
        <span>
          Demo Environment
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EnvironmentBanner',
  data() {
    return {
      currEnv: process.env.CURRENT_ENV,
    };
  },
};
</script>

<style lang ="scss">
.banner-container{
  display: flex;
  justify-content: right;
  flex-direction: row;
  background-color: $BLACK;
}
.banner-dev{
  width: 100%;
  background-color: #F83356;
  color: white;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
.banner-stage {
  width: 100%;
  background-color: #FFAB00;
  color: black;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
